import { Injectable, Injector, inject } from '@angular/core';

import { ScrollFreezeServiceTypes } from '@frontend/sports/common/core/feature/scroll-freeze';
import { ModalDialogOptions, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';

import { QuickBetPlaceBetErrorModalComponent } from '../components/result/quick-bet-place-bet-error-modal.component';
import { QuickBetTechnicalErrorModalComponent } from '../components/result/quick-bet-technical-error-modal.component';

@Injectable()
export class QuickBetModalDialogService {
    private dialogOptions: ModalDialogOptions<void>;

    constructor(private modalDialogService: ModalDialogService) {
        this.dialogOptions = {
            settings: {
                scrollFreezeType: ScrollFreezeServiceTypes.Page,
                injector: inject(Injector),
            },
        };
    }

    openTechnicalErrorDialog(): ModalRef {
        const modalRef = this.modalDialogService.openDialog(QuickBetTechnicalErrorModalComponent, this.dialogOptions);

        return modalRef;
    }

    openPlaceBetErrorDialog(): ModalRef {
        const modalRef = this.modalDialogService.openDialog(QuickBetPlaceBetErrorModalComponent, this.dialogOptions);

        return modalRef;
    }
}
